<generic-page
  image="calculatorNotEligible"
  [hidePortalMenu]="true"
  [showAppHeader]="false"
  [columnLayout]="false"
  >
  <div class="container">
    <mat-card>
      <div class="header">Ygrene is not available in your area.</div>

      <p class="description">
        We are always working to add new neighborhoods. Check back soon.
      </p>

      @if (isDesktop$ | async) {
        <div class="button-wrapper">
          <page-button [config]="{ arrow: 'right' }" (clicked)="navigate()"
            >Check Another Property</page-button
            >
          </div>
        }
      </mat-card>
    </div>
  </generic-page>

  @if (!(isDesktop$ | async)) {
    <div class="footer-wrapper" noShadowOnBottom>
      <page-footer
        [primary]="{ label: 'Check Another Property', arrow: 'right' }"
        [primCenteredIfNoSecondary]="true"
        (primaryClicked)="navigate()"
        [valid]="true"
      ></page-footer>
    </div>
  }
